export const ExpStoreFlow = [
  //idx 0 of '/stores'
  [
    {
      type: "comment",
      hint: ["你好~我是大咖,你的咖啡好幫手"]
    },
    {
      type: "select",
      hint: ["讓我們一起來找找台灣最推薦的私藏的優質咖啡店吧!"],
      choices: [
        { label: "哇!好想知道大咖的私藏咖啡店噢", value: 1 },
        { label: "我們來研究研究吧,快點告訴我", value: 2 },
        { label: "好想嚐嚐台灣最優質的咖啡店噢!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: [
        "大咖來幫你挑一款最推薦的私藏咖啡風味,引路咖啡的這款咖啡風味希望你會喜歡"
      ]
    }
  ],
  //idx 1 of '/stores'
  [
    {
      type: "comment",
      hint: ["hey!我是大咖,讓我來幫你找到自己喜歡的口味"]
    },
    {
      type: "select",
      hint: [
        "讓大咖來跟你分享我最喜歡的咖啡店中,最推薦的私藏的優質咖啡風味吧!"
      ],
      choices: [
        { label: "我也好想煮出跟咖啡店一樣好喝的咖啡噢!", value: 1 },
        { label: "我要我要!", value: 2 },
        { label: "好想找到最適合我的優質咖啡噢", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["來吧!大咖推薦這款咖創的好品味咖啡,希望能讓你愛不釋手"]
    }
  ],
  //idx 2 of '/stores'
  [
    {
      type: "comment",
      hint: ["hello!我是咖啡專業100的大咖,我來幫你找到屬於你的品味"]
    },
    {
      type: "select",
      hint: ["大咖偷偷告訴你大咖收藏的咖啡店中,最棒的咖啡風味是哪一款吧!"],
      choices: [
        { label: "耶!大咖快點告訴我!", value: 1 },
        { label: "好想知道,我不會告訴別人的!", value: 2 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores"
        }
      }
    },
    {
      type: "comment",
      hint: [
        "Moonshine cafe就是這款最優了,偷偷跟你說,這是大咖的私藏,不要告訴太多人噢!"
      ]
    }
  ],
  //idx 3 of '/stores'
  [
    {
      type: "comment",
      hint: ["hi,我是專屬咖啡師大咖,找咖啡和我聊聊就對了!"]
    },
    {
      type: "select",
      hint: ["讓大咖陪你一起挑選好咖嚴選的咖啡店中,最溫順的咖啡口感有哪些唄!"],
      choices: [
        { label: "哇!我最愛去好咖嚴選的精選咖啡店噢,快快推薦我!", value: 1 },
        { label: "大咖快來幫我一起選", value: 2 },
        { label: "我要最好喝的那一款!", value: 3 }
      ],
      extra: {
        type: "single-select",
        redirectUrl: {
          1: "/products",
          2: "/stores",
          3: "/find-by-map"
        }
      }
    },
    {
      type: "comment",
      hint: ["來吧!這款是Stopover cafe所有狂粉都愛的咖啡風味,分享給你嚐嚐!"]
    }
  ]
];
